import React, { useEffect } from "react";
import { Slice } from "gatsby";
import { useSettings } from "hooks/useStore";
import ToastContainer from "components/toast-container";
import SiteRichSnippet from "rich-snippets";
import SkipNavLinks from "components/skip-nav-links";
import Scripts from "scripts";
import CookieConsentBanner from "components/cookie-consent";

const BaseLayout = ({ pageSettings, previewSettings = {}, children }) => {
	const { initializeAppState } = useSettings(["initializeAppState"]);

	useEffect(() => {
		initializeAppState();
	}, []);

	return (
		<>
			<SkipNavLinks />
			<Slice previewData={previewSettings.cart} alias="cart" />
			{!pageSettings?.hideHeader &&
				<>
					<Slice
						previewData={previewSettings.announcementBar} alias="announcement-bar" pageSettings={pageSettings} />
					<Slice
						previewData={previewSettings.header} alias="header" pageSettings={pageSettings} />
				</>
			}
			{!pageSettings?.hideSaleBanner &&
				<Slice previewData={previewSettings?.saleBanner} alias="sale-banner" />}
			<ToastContainer />
			<main id="main-content" tabIndex={-1} className={pageSettings?.latoFont ? "font-lato" : ""}>
				{children}
			</main>
			{!pageSettings?.hideFooter &&
				<Slice previewData={previewSettings.footer} alias="footer" pageSettings={pageSettings} />}
			<CookieConsentBanner />
			<SiteRichSnippet />
			<Scripts />
		</>
	);
};

export default BaseLayout;